const S3 = (process.env.REACT_APP_S3_PATH || '').trim();

export function joinPublicAssetUrl(base, pathOrFilename) {
  if (!pathOrFilename) return '';
  const s = String(pathOrFilename).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const b = base.replace(/\/+$/, '');
  if (!b) return '';
  const rel = s.replace(/^\/+/, '');
  const joined = `${b}/${rel.split('/').map((seg) => encodeURIComponent(seg)).join('/')}`;
  return joined.replace(/%2F/g, '/');
}

/** Same URL rules as the game scene (`game.jsx` s3Url). */
export function s3ThemeAssetUrl(filename) {
  return joinPublicAssetUrl(S3, filename);
}
